import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// import Header from "./Component/Header/Header";
import Login from "./Component/Login/Login";
import Dashboard from "./Component/Dashboard/Dashboard";
import Users from "./Component/Users/Users";
import Withdraw from "./Component/Withdraw/Withdraw";
import Payments from "./Component/Payments/Payments";
import SupportTicket from "./Component/SupportTicket/SupportTicket";
import UserReports from "./Component/UserReports/UserReports";
import Packages from "./Component/Packages/Packages";
import Coupons from "./Component/Coupons/Coupons";
import UpdateSettings from "./Component/UpdateSettings/UpdateSettings";
import RedisManagement from "./Component/RedisManagement/RedisManagement";
import LogViewer from "./Component/LogViewer/LogViewer";
import CrashLogs from "./Component/CrashLogs/CrashLogs";
import PaymentErrors from "./Component/PaymentErrors/PaymentErrors";
import Attack from "./Component/Attack/Attack";
import CommunicationAnalytics from "./Component/CommunicationAnalytics/CommunicationAnalytics";
import EventAnalytics from "./Component/EventAnalytics/EventAnalytics";
import AttributionAnalytics from "./Component/AttributionAnalytics/AttributionAnalytics";
import FunnelAnalytics from "./Component/FunnelAnalytics/FunnelAnalytics";
import UserProgress from "./Component/UserProgress/UserProgress";
import OrdersRevenue from "./Component/OrdersRevenue/OrdersRevenue";
import Signups from "./Component/Signups/Signups";
import Visitors from "./Component/Visitors/Visitors";
import SmsAnalytics from "./Component/SmsAnalytics/SmsAnalytics";
import PushNotifications from "./Component/PushNotifications/PushNotifications";
import Profile from "./Component/Profile/Profile";
import Settings from "./Component/Settings/Settings";
import Notifications from "./Component/Notifications/Notifications";
import Layout from "./Component/Layout/Layout";
import CampaignList from "./Component/Campaign/CampaignList";
import CreateCampaign from "./Component/Campaign/CreateCampaign";
import CampaignDetails from "./Component/Campaign/CampaignDetails";
import MarketingSettings from "./Component/MarketingSettings/MarketingSettings";
import MarketingSummary from "./Component/Marketing/MarketingSummary";
import ReminderResults from "./Component/Marketing/ReminderResults";
import Automations from "./Component/Marketing/Automations";
import AICallingControl from "./Component/AICalling/AICallingControl";
import AICallingSip from "./Component/AICalling/AICallingSip";
import AICallingSettings from "./Component/AICalling/AICallingSettings";
import AICallingCampaigns from "./Component/AICalling/AICallingCampaigns";
import AICallingCampaignDetail from "./Component/AICalling/AICallingCampaignDetail";
import AICallingLive from "./Component/AICalling/AICallingLive";
import AICallingCalls from "./Component/AICalling/AICallingCalls";
import AICallingCallDetail from "./Component/AICalling/AICallingCallDetail";
import AICallingDnc from "./Component/AICalling/AICallingDnc";
import AICallingReports from "./Component/AICalling/AICallingReports";
import AICallingTicketAgent from "./Component/AICalling/AICallingTicketAgent";
import HealthCheck from "./Component/HealthCheck/HealthCheck";
import AppConfig from "./Component/AppConfig/AppConfig";
import UserManagement from "./Component/UserManagement/UserManagement";
import ProtectedRoute from "./Component/ProtectedRoute/ProtectedRoute";

const App = () => {
  function PrivateRoute({ children }) {
    const token = localStorage.getItem("token");
    if (!token) {
      return <Navigate to="/login" replace />;
    }
    return children;
  }

  function IsLogin({ children }) {
    const token = localStorage.getItem("token");
    const IsAdmin = localStorage.getItem("IsAdmin");
    const AdminType = localStorage.getItem("AdminType");

    if (token && IsAdmin && AdminType === "Supper") {
      return <Navigate to="/dashboard" replace />;
    } else if (token && IsAdmin && AdminType === "Admin") {
      return <Navigate to="/dashboard" replace />;
    } else if (token && IsAdmin && AdminType === "Team") {
      return <Navigate to="/users" replace />;
    } else if (token && IsAdmin && AdminType === "CallCenter") {
      return <Navigate to="/users" replace />;
    } else {
      return children;
    }
  }

  // Helper component to handle default route redirect
  function DefaultRoute() {
    const AdminType = localStorage.getItem("AdminType");
    if (AdminType === "CallCenter" || AdminType === "Team") {
      return <Navigate to="/users" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={
            <IsLogin>
              <Login />
            </IsLogin>
          }
        />
        
        {/* Protected routes with shared layout */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index element={<DefaultRoute />} />
          
          {/* Routes accessible to all admin roles */}
          <Route 
            path="users" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team", "CallCenter"]}>
                <Users />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="user-management" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team", "CallCenter"]}>
                <UserManagement />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="payments" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team", "CallCenter"]}>
                <Payments />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="profile" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team", "CallCenter"]}>
                <Profile />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="settings" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team", "CallCenter"]}>
                <Settings />
              </ProtectedRoute>
            } 
          />

          {/* Routes accessible to Supper, Admin, and Team only */}
          <Route 
            path="dashboard" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team"]}>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="withdraw" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team"]}>
                <Withdraw />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="packages" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team"]}>
                <Packages />
              </ProtectedRoute>
            } 
          />
          <Route
            path="coupons"
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin"]}>
                <Coupons />
              </ProtectedRoute>
            }
          />
          <Route 
            path="support-ticket" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team"]}>
                <SupportTicket />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="user-reports" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team"]}>
                <UserReports />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="user-progress" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team"]}>
                <UserProgress />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="orders-revenue" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team"]}>
                <OrdersRevenue />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="signups" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team"]}>
                <Signups />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="visitors" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team"]}>
                <Visitors />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="sms-analytics" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team"]}>
                <SmsAnalytics />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="push-notifications" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team"]}>
                <PushNotifications />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="communication-analytics" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team"]}>
                <CommunicationAnalytics />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="event-analytics" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team"]}>
                <EventAnalytics />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="attribution-analytics" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team"]}>
                <AttributionAnalytics />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="funnel-analytics" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team"]}>
                <FunnelAnalytics />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="campaigns" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team"]}>
                <CampaignList />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="campaign/create" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team"]}>
                <CreateCampaign />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="campaign/:campaignId" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team"]}>
                <CampaignDetails />
              </ProtectedRoute>
            } 
          />
          <Route
            path="campaign/edit/:campaignId"
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team"]}>
                <CreateCampaign />
              </ProtectedRoute>
            }
          />
          {/* Viewable by campaign roles; who may save is set on the page itself */}
          <Route
            path="marketing/settings"
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team"]}>
                <MarketingSettings />
              </ProtectedRoute>
            }
          />
          {/* Marketing results, reminders and automations (access checked by the backend) */}
          <Route
            path="marketing/summary"
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team", "CallCenter"]}>
                <MarketingSummary />
              </ProtectedRoute>
            }
          />
          <Route
            path="marketing/reminders"
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team", "CallCenter"]}>
                <ReminderResults />
              </ProtectedRoute>
            }
          />
          <Route
            path="marketing/automations"
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team", "CallCenter"]}>
                <Automations />
              </ProtectedRoute>
            }
          />
          {/* AI Calling (roles from Marketing settings → Access; the backend checks every request) */}
          <Route
            path="ai-calling"
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team", "CallCenter"]}>
                <AICallingControl />
              </ProtectedRoute>
            }
          />
          <Route
            path="ai-calling/sip"
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team", "CallCenter"]}>
                <AICallingSip />
              </ProtectedRoute>
            }
          />
          <Route
            path="ai-calling/settings"
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team", "CallCenter"]}>
                <AICallingSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="ai-calling/campaigns"
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team", "CallCenter"]}>
                <AICallingCampaigns />
              </ProtectedRoute>
            }
          />
          <Route
            path="ai-calling/campaigns/:campaignId"
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team", "CallCenter"]}>
                <AICallingCampaignDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="ai-calling/live"
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team", "CallCenter"]}>
                <AICallingLive />
              </ProtectedRoute>
            }
          />
          <Route
            path="ai-calling/calls"
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team", "CallCenter"]}>
                <AICallingCalls />
              </ProtectedRoute>
            }
          />
          <Route
            path="ai-calling/calls/:callId"
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team", "CallCenter"]}>
                <AICallingCallDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="ai-calling/dnc"
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team", "CallCenter"]}>
                <AICallingDnc />
              </ProtectedRoute>
            }
          />
          <Route
            path="ai-calling/reports"
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team", "CallCenter"]}>
                <AICallingReports />
              </ProtectedRoute>
            }
          />
          <Route
            path="ai-calling/ticket-agent"
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin", "Team", "CallCenter"]}>
                <AICallingTicketAgent />
              </ProtectedRoute>
            }
          />

          {/* Routes accessible to Supper and Admin only */}
          <Route 
            path="update-settings" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin"]}>
                <UpdateSettings />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="redis-management" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin"]}>
                <RedisManagement />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="logs" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin"]}>
                <LogViewer />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="crash-logs" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin"]}>
                <CrashLogs />
              </ProtectedRoute>
            } 
          />
          <Route
            path="payment-errors"
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin"]}>
                <PaymentErrors />
              </ProtectedRoute>
            }
          />
          <Route
            path="attack"
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin"]}>
                <Attack />
              </ProtectedRoute>
            }
          />
          <Route 
            path="health-check" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin"]}>
                <HealthCheck />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="app-config" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin"]}>
                <AppConfig />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="notifications" 
            element={
              <ProtectedRoute allowedRoles={["Supper", "Admin"]}>
                <Notifications />
              </ProtectedRoute>
            } 
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
